import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledInput = styled(InnerComponent).attrs({
  Component: components.Input,
  maxLength: 2,
})`
  input {
    cursor: pointer;
  }
`

const Input = props => {
  return <StyledInput {...props} />
}

export default Input
